export const AVAILABLE_COUNTRIES_MAP = new Map<string, string[]>([
  ['android', ['GB', 'IE']],
  // ['ios', ['GB']] // disabled because it has native support by <meta>
]);
